import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import * as actions from '../actions/sites';
import { getAllSites } from '../reducers/requirements';
import { getCaseSites } from '../reducers/sites';
import { getAllErrors } from '../reducers/errors';
import SiteSelector from '../components/SiteSelector';
import SiteTabs from '../components/SiteTabs';

const mapStateToProps = state => ({
  sites: getAllSites(state),
  caseSites: getCaseSites(state),
  errors: getAllErrors(state),
});

const SitesLayout = ({
  customer,
  children,
  sites,
  caseSites,
  errors,
  addSite,
  selectSite,
  unselectSite,
}) => (
  <div>
    <SiteSelector
      customer={customer}
      sites={sites}
      selected={caseSites}
      onAdded={addSite}
      onSelected={selectSite}
      onUnselected={unselectSite}
      errors={errors}
    />
    <SiteTabs sites={caseSites} errors={errors} />
    {children}
  </div>
);

SitesLayout.propTypes = {
  customer: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  sites: PropTypes.array.isRequired,
  caseSites: PropTypes.array.isRequired,
  errors: ImmutablePropTypes.map.isRequired,
  addSite: PropTypes.func.isRequired,
  selectSite: PropTypes.func.isRequired,
  unselectSite: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, actions)(SitesLayout);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/layouts/SitesLayout.js